"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _VideoButton = _interopRequireDefault(require("./VideoButton"));

var _Overlay = _interopRequireDefault(require("./Overlay"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var TheaterVideo = /*#__PURE__*/function (_React$Component) {
  _inherits(TheaterVideo, _React$Component);

  var _super = _createSuper(TheaterVideo);

  function TheaterVideo(props) {
    var _this;

    _classCallCheck(this, TheaterVideo);

    _this = _super.call(this, props);
    _this.state = {
      form: "two-lines",
      position: "right",
      isOpen: false,
      isOpening: false,
      isClosing: false
    };
    _this.toggleTheater = _this.toggleTheater.bind(_assertThisInitialized(_this));
    _this.escFunction = _this.escFunction.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TheaterVideo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var menu = document.getElementById("mainNav");
      var pause = document.getElementById("sizzlePause");
      this.menu = menu;
      this.pauseButton = pause;
      document.addEventListener("keydown", this.escFunction, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.escFunction, false);
    }
  }, {
    key: "escFunction",
    value: function escFunction(event) {
      if (event.keyCode === 27 && this.state.isOpen) {
        this.toggleTheater();
      }
    }
  }, {
    key: "toggleTheater",
    value: function toggleTheater() {
      var _this2 = this;

      //todo
      if (this.state.isOpen) {
        if (this.pauseButton) {
          setTimeout(function () {
            _this2.pauseButton.style.display = "block";
          }, 450);
        }

        this.setState(function (prevState) {
          return _objectSpread({}, prevState, {
            isClosing: !prevState.isClosing,
            playing: false
          });
        }, function () {
          var _this3 = this;

          setTimeout(function () {
            _this3.setState(function (prevState) {
              return _objectSpread({}, prevState, {
                isOpen: !prevState.isOpen,
                isClosing: !prevState.isClosing
              });
            });

            _this3.menu.style.zIndex = "100";
          }, 450);
        }); // Make sure to sync this setTimeout time with the one in the .scss animation time
      } else if (!this.state.isOpen) {
        this.menu.style.zIndex = "0";

        if (this.pauseButton) {
          this.pauseButton.style.display = "none";
        }

        this.setState(function (prevState) {
          return _objectSpread({}, prevState, {
            isOpen: !prevState.isOpen,
            isOpening: !prevState.isOpening
          });
        });
        setTimeout(function () {
          _this2.setState(function (prevState) {
            return _objectSpread({}, prevState, {
              isOpening: !prevState.isOpening,
              playing: true
            });
          });
        }, 450); // Make sure to sync this setTimeout time with the one in the .scss animation time
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var childrenWithProps = _react["default"].Children.map(this.props.children, function (child) {
        return _react["default"].cloneElement(child, {
          onClick: _this4.toggleTheater
        });
      });

      var hasWatchVideo = true;
      var onlyButton = false;
      var overVideo = false;
      var controls = true;
      var playing = true;
      var sizzleButton = false;

      if (this.props.hasWatchVideo === false) {
        hasWatchVideo = false;
      }

      if (this.props.onlyButton === true) {
        onlyButton = true;
      } else {
        if (this.props.overVideo === true) {
          overVideo = true;
        }
      }

      if (this.props.controls === false) {
        controls = false;
      }

      if (this.props.playing === false) {
        playing = false;
      }

      if (this.props.sizzleButton === true) {
        sizzleButton = true;
      }

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Overlay["default"], {
        toggleTheater: this.toggleTheater,
        isOpen: this.state.isOpen,
        isClosing: this.state.isClosing,
        isOpening: this.state.isOpening,
        videoUrl: this.props.videoUrl,
        controls: controls,
        playing: playing,
        className: this.props.containerClass //ext={this.extControl}

      }), hasWatchVideo && !onlyButton && /*#__PURE__*/_react["default"].createElement("div", {
        className: "image-button-wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_VideoButton["default"], {
        buttonText: this.props.buttonText,
        textOnly: this.props.textOnly,
        language: this.props.language,
        toggleTheater: this.toggleTheater,
        overVideo: overVideo,
        iconOnly: this.props.iconOnly,
        buttonClass: this.props.buttonClass
      }), this.props.children), onlyButton && sizzleButton && /*#__PURE__*/_react["default"].createElement("div", {
        className: "button-group is-centered-mobile",
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/_react["default"].createElement(_VideoButton["default"], {
        buttonText: this.props.buttonText,
        textOnly: this.props.textOnly,
        language: this.props.language,
        toggleTheater: this.toggleTheater,
        overVideo: overVideo,
        iconOnly: this.props.iconOnly,
        sizzleButton: sizzleButton,
        buttonClass: this.props.buttonClass
      })), onlyButton && !sizzleButton && this.props.slideButton && /*#__PURE__*/_react["default"].createElement("div", {
        className: "slideVidButton"
      }, /*#__PURE__*/_react["default"].createElement(_VideoButton["default"], {
        buttonText: this.props.buttonText,
        textOnly: this.props.textOnly,
        language: this.props.language,
        toggleTheater: this.toggleTheater,
        overVideo: overVideo,
        iconOnly: this.props.iconOnly,
        buttonClass: this.props.buttonClass
      })), onlyButton && !sizzleButton && !this.props.slideButton && /*#__PURE__*/_react["default"].createElement(_VideoButton["default"], {
        buttonText: this.props.buttonText,
        textOnly: this.props.textOnly,
        language: this.props.language,
        toggleTheater: this.toggleTheater,
        overVideo: overVideo,
        iconOnly: this.props.iconOnly,
        buttonClass: this.props.buttonClass
      }), !hasWatchVideo && childrenWithProps);
    }
  }]);

  return TheaterVideo;
}(_react["default"].Component);

TheaterVideo.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  videoUrl: _propTypes["default"].string.isRequired,
  controls: _propTypes["default"].bool,
  playing: _propTypes["default"].bool,
  overVideo: _propTypes["default"].bool,
  hasWatchVideo: _propTypes["default"].bool,
  onlyButton: _propTypes["default"].bool,
  sizzleButton: _propTypes["default"].bool
};
var _default = TheaterVideo;
exports["default"] = _default;

//# sourceMappingURL=TheaterVideo.js.map